export var FS_PROPS;
(function (FS_PROPS) {
    FS_PROPS["PROPS"] = "_fs_props";
})(FS_PROPS || (FS_PROPS = {}));
